import { useState } from "react";

import Alert from "../components/Alert";

import Form from "./Form";

const Tickets = () => {
	const [details, setDetails] = useState({});
	const [alert, setAlert] = useState({});

	const handleSubmitted = (text) => {
		setAlert({
			type: "success",
			text,
		});
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Form details={details} submitted={handleSubmitted} />
			)}
		</>
	);
};

export default Tickets;
